import React from 'react';
import {
  Paper,
  Typography,
  makeStyles,
  Link as MuiLink
} from '@material-ui/core';
import { ArrowBackIos as ArrowBackIosIcon } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AnimatedLayout } from '../../components';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 364,
    padding: theme.spacing(3)
  },
  text: {
    margin: '16px 0'
  },
  link: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& > p': {
      fontWeight: 600,
      lineHeight: '24px'
    }
  }
}));

export interface IError {
  title: string;
  text: string;
}

export const Error: React.FC<IError> = ({ title, text }) => {
  const classes = useStyles();
  const { t } = useTranslation('errors');
  return (
    <AnimatedLayout disableLogo>
      <Paper className={classes.container}>
        <Typography variant="h4">{title}</Typography>
        <Typography className={classes.text}>{text}</Typography>
        <MuiLink component={Link} to="/" className={classes.link}>
          <ArrowBackIosIcon fontSize="small" />
          <Typography>{t('backToSite')}</Typography>
        </MuiLink>
      </Paper>
    </AnimatedLayout>
  );
};

export default Error;
